
export const EVENT_ON_ORDER_UPDATE = 'on:order:update';

export const EVENT_ON_CART_OPEN = 'on:cart:open';

export const EVENT_ON_CART_CLOSE = 'on:cart:close';

export const EVENT_ON_CART_ERROR = 'on:cart:error';
